import { Grid, Modal as ModalModule, UI } from 'common';
import isNull from 'lodash/isNull';
import isObject from 'lodash/isObject';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';

import DateCellRenderer from '../shared/DateCellRenderer.component';
import HistoryCommunication from '../utils/HistoryCommunication';

const { Modal, ModalContext } = ModalModule;
const { WrappedToolbar, Spinner } = UI;
const { GridPanel } = Grid;

const columnDefs = [
	{
		headerName: 'Ship Date',
		field: 'date_created',
		width: 120,
		valueGetter: ({ data }) => moment(data.shipDate).toDate(),
		cellRenderer: 'DateCellRenderer',
	},
	{
		headerName: 'DHLeC Manifest Number',
		field: 'manifest_id',
		sort: 'asc',
		width: 200,
		flex: 1,
	},
	{
		headerName: '# of Items',
		field: 'number_of_items_in_manifest',
		width: 120,
	},
];

const ReprintDHLeCModal = ({ modalId }) => {
	const { showError } = useContext(ModalContext);

	const [selectedManifest, setSelectedManifest] = useState(null);
	const [printManifestValue, setPrintManifestValue] = useState(null);

	const [manifests, setManifests] = useState([]);
	const [isLoading, setLoading] = useState(true);

	useEffect(() => {
		const fetchManifests = async () => {
			let domesticManifests = [];
			let internationalManifests = [];

			setLoading(true);

			// concurrently call to retrieve domestic and international manifests
			const [domesticResponse, internationalResponse] = await Promise.all([
				HistoryCommunication.getPrintedManifestsDHLeC('domestic'),
				HistoryCommunication.getPrintedManifestsDHLeC('international'),
			]);

			if (HistoryCommunication.isSuccessful(domesticResponse)) {
				domesticManifests = domesticResponse.data.manifests || [];

				if (HistoryCommunication.isSuccessful(internationalResponse)) {
					internationalManifests = internationalResponse.data.manifests || [];
				} else {
					showError({ internationalResponse });
				}
			} else {
				showError({ domesticResponse });
			}

			// combine the manifests from both responses
			setManifests([...domesticManifests, ...internationalManifests]);

			setLoading(false);
		};

		fetchManifests();
	}, []);

	const getManifestUrls = async () => {
		const reprintManifestResponse =
			await HistoryCommunication.reprintManifestDHLeC(
				selectedManifest.manifest_id
			);

		if (HistoryCommunication.isSuccessful(reprintManifestResponse)) {
			const { labels } = reprintManifestResponse.data;
			const urls = labels.map(label => label.href);

			selectedManifest.urls = urls;

			setPrintManifestValue(0);
		} else {
			showError({ reprintManifestResponse });
		}
	};

	const printManifest = () => {
		getManifestUrls();
	};

	const toolbarButtons = [
		{
			label: 'Print DHLeCommerce Manifest',
			icon: 'print-icon',
			onClick: printManifest,
			disabled: !isObject(selectedManifest),
		},
	];

	const onSelectionChanged = selection => {
		const selectedReprintManifest =
			selection.length > 0 ? selection[0].data : null;

		setSelectedManifest(selectedReprintManifest);
	};

	return (
		<>
			<Modal
				modalId={modalId}
				className="history-manifest reprint-manifest-modal"
				header="Reprint DHL eCommerce Manifest"
				hideFooter
			>
				<WrappedToolbar
					className="toolbar"
					buttons={toolbarButtons}
					dataqa="reprint-dhl-ecommerce-toolbar"
				/>
				<GridPanel
					columnDefs={columnDefs}
					defaultColDef={{
						suppressSizeToFit: true,
						suppressMovable: true,
						sortable: false,
						suppressMenu: true,
					}}
					rowData={manifests}
					showPagination={false}
					rowSelection="single"
					onSelectionChanged={onSelectionChanged}
					frameworkComponents={{ DateCellRenderer }}
				/>
				{isLoading && (
					<Spinner msg="Loading Reprint DHL eCommerce Manifest..." />
				)}
			</Modal>
			{!isNull(printManifestValue) && (
				<Modal
					modalId={modalId}
					className="history-manifest manifest-pdf-modal"
					header="Reprint DHL eCommerce Manifest"
					hideFooter
				>
					<div>
						{selectedManifest.urls.map((url, index) => (
							<iframe
								title="Reprint DHL eCommerce Manifest"
								key={index}
								src={url}
								width="100%"
								height="900"
							/>
						))}
					</div>
				</Modal>
			)}
		</>
	);
};

ReprintDHLeCModal.propTypes = {};

export default ReprintDHLeCModal;
